<template>
  <prk-table
      v-if="item.value.value.length > 0"
      :show-headline="false"
      :items="item.value.value.slice(1, item.value.length)"
      :show-footer="true"
      :custom-class="true"
      :show-html="status === 'accepted' || status === 'to_verification' || !editMode"
      html-cell-class="syllabus-content-typography"
  >
    <template v-slot:table-colgroup="{ fields }">
      <col v-for="field in fields" :key="field.key"
           :style="{ width: field.key === 'actions' ? '5%' : '' }"
      >
    </template>
    <template v-for="(label, key, index) in item.value.value[0]" v-slot:[`head(value${index})`]
    >
      <span :key="index">{{ label || `${$t('general.heading')} ${index + 1}` }}</span>
    </template>
    <template v-slot:content="{ header, data }">
      <prk-editor v-if="header.key !== 'actions' && !basic" v-model="data.item[header.key]" />
      <div v-else-if="header.key !== 'actions' && basic"
           class="syllabus-content-typography">
        {{ data.item[header.key] }}
      </div>
      <base-button-remove
          v-else-if="data.index > 0 && status !== 'accepted' && editMode"
          text="delete_row"
          @click="removeRow(data.index + 1, item.value.value)"
      />
    </template>
    <template v-if="fillContent && editMode" v-slot:custom-foot>
      <add-row :items="item.value.value" @addRow="$emit('addRow', $event)"/>
    </template>
  </prk-table>
</template>

<script>
import PrkEditor from '../../PrkEditor'
import PrkTable from '../../PrkTable'
import AddRow from '../../TableHelpers/PrkAddRow'
import useList from '../../../composables/useList'
import { inject } from '@vue/composition-api'
import { fillStatus } from '../../../mixins/syllabus/status'

export default {
  name: 'SyllabusTable',
  setup (props, { root }) {
    const status = inject('status', 'template')
    const editMode = inject('editMode', true)
    const { removeRow } = useList(root)
    return {
      editMode,
      removeRow,
      status,
    }
  },
  components: {
    PrkTable,
    AddRow,
    PrkEditor,
  },
  mixins: [fillStatus],
  props: {
    basic: {
      type: Boolean,
      default: false,
    },
    item: {
      required: true,
      type: Object,
    },
  },
  watch: {
    'item.value' (newVal) {
      if (newVal.length === 1) this.item.value.value = []
    },
  },
}
</script>

<style scoped lang="scss">
@import "app/javascript/prk/assets/stylesheets/vars.scss";

::v-deep .syllabus-content-typography {
  font-family: Arial, sans-serif !important;
  font-size: 15pt !important;
  line-height: 1.4 !important;
}

::v-deep .syllabus-content-typography {
  p,
  div,
  span,
  ol,
  ul,
  li {
    font-family: Arial, sans-serif !important;
    font-size: 15pt !important;
    line-height: 1.4 !important;
  }

  ol,
  ul {
    margin-bottom: 14px;
  }

  li {
    margin-bottom: 4px;
  }
}
</style>
